<template>
    <div class="login_container">
        <div class="login_body">
            <div class="login_bg">
<!--                <img style="width: 100%;height: 100%" :src="$UIConfig.loginBackground" alt />-->
            </div>
            <div class="login_option">
              <h1 class="field_title fs24">请输入密码</h1>
              <w-input
                :type="loginInfo.password.showPassword ? 'text' : 'password'"
                placeholder="密码"
                err-msg="请输入密码"
                :value-obj="loginInfo.password"
                @keydown.native.enter="toLogin"
              >
                <img class="field_clear"
                  :src="loginInfo.password.showPassword ? openEye : closeEye"
                  @click.stop="loginInfo.password.showPassword = !loginInfo.password.showPassword"/>
              </w-input>
              <!-- 登录 -->
              <el-button
                v-waves
                type="primary"
                class="login_btn"
                :loading="loginLoading"
                @click="toLogin"
              >确认</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import loginMixin from './mixin/login';
import welcomeLogin from './components/welcome-login.vue';
const ipcRenderer = window.require ? window.require('electron').ipcRenderer : '';

export default {
    name: 'login',
    mixins: [loginMixin],
    components: {
        WInput: {
            template: `
                <div class="field_wrapper">
                    <!-- input -->
                    <el-input class="field_item SysFontM" :class="{'err_border': valueObj.err}" :type="type" v-model.trim="valueObj.value"
                           :placeholder="placeholder" @blur="onBlur" @focus="valueObj.err=false"></el-input>
                    <!-- input error信息 -->
                    <span class="field_errMsg" v-if="valueObj.err">{{ errMsg }}</span>

                    <slot>

                    </slot>
                </div>
            `,
            props: ['type', 'placeholder', 'errMsg', 'valueObj'],
            data () {
                return {
                    closeImg: require('./images/close.svg')
                }
            },
            methods: {
                onBlur () {
                    const obj = this.valueObj
                    if (!obj.reg.test(obj.value)) {
                        obj.err = true
                    }
                },
                clear () {
                    this.valueObj.value = ''
                }

            }
        },
        welcomeLogin
    },
    data () {
        return {
            showPrivacy: false,
            chooseLanguage: '',
            loginType: 'email',
            loginLoading: false,
            CFAEntry: false,
            loginInfo: { // 登录信息
                email: { value: '', reg: /^\S{2,32}$/, err: false },
                password: { value: '', reg: /^\S{4,18}$/, err: false, showPassword: true, },
                phone: { value: '', reg: /^1\d{10}$/, err: false },
                code: { value: '', reg: /^\d{4,6}$/, err: false },
            },
            phoneImg: require('./images/phone.svg'),
            emailImg: require('./images/email.svg'),
            accountImg: require('./images/account.svg'),
            openEye: require('./images/open_eye.svg'),
            closeEye: require('./images/close_eye.svg'),
            closeImg: require('./images/close.svg'),
            countDown: 0,
            showCount: 0,
            timer: null,
            dialogShow: false,
            resetStep: 0,
            resetPassword: {
                email: '',
                verifyCode: '',
                password: '',
            },
          fixPwd: 'cfa123',
            loginAnimation: false
        }
    },

    destroyed () {
        clearInterval(this.timer)
    },

    mounted () {
        this.clearCache();
        this.chooseLanguage = this.$sg.ls.get('language') || 'zh'
        this.$store.commit('setLanguage', this.chooseLanguage)
    },

    methods: {
        clearCache () {
            this.$store.dispatch('LogOut').then(res => {
                if (res === 'success') {
                    this.$sg.ss.clear()
                }
            })
        },
        /* 点击登录 */
        async toLogin () {
          await this.$nextTick()

          if (this.loginInfo.password.value == 'cfa123' || this.loginInfo.password.value == 'cfa-w') {
            this.loginSuccess('1234567890', this.loginInfo.password.value)
          } else {
            this.$message.error('密码不正确')
          }
        },

        loginSuccess (loginSuccessData, pwd) {
          console.log(pwd)
          this.$sg.ss.set("store", this.$store.state)
          this.$store.commit('setToken', loginSuccessData);
          this.$store.commit('setDataType', pwd == 'cfa-w'?'woman':'all');
          this.$router.push({
            path: pwd == 'cfa-w'?'/home-woman':'/home',
          })
        },
    }
}
</script>

<style lang="scss" scoped>
/* 清除 */
.resetButton {
    outline: none;
    background: none;
    border: none;
}

.login_container {
    width: 100%;
    height: 100%;
    position: relative;
    .login_body {
      width: 100%;
      height: 100%;
      position: relative;
    }
}

.login_bg {
    height: 100%;
    width: 100%;
  background-color: #ffffff;
}

.login_option {
    height: 300px;
    background: #ffffff;
    position: fixed;
    width: 400px;
  z-index: 10;
    top: 200px;
    box-sizing: border-box;
    padding: 30px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 10px 20px 100px 0px #00000014;
  left: calc(50% - 200px);
}

.login_option {

    .field_title {
        margin-bottom: 30px;
        line-height: 42px;
        font-weight: 800;
        color: #000000;
      text-align: center;
    }

    /* input父级div */
    /deep/ .field_wrapper {
        position: relative;
        height: 56px;

        /* input */
        .field_item {
            @extend .resetButton;
            width: 100%;
            font-size: 18px;
            line-height: 56px;
            color: #000000;

            input {
                font-size: 16px;
                height: 56px;
                //border: 1px solid #e9edf3;
                border-radius: 4px;
                padding-right: 50px;
            }
            &.err_border {
                input {
                    border: 1px solid #ff5630;
                }
            }

            /* 聚焦时加box-shadow */
            &:focus + .boxShadow {
                background: #000000;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
            }

            /* placeholder样式 */
            &::-webkit-input-placeholder {
                font-size: 16px;
                line-height: 22px;
                color: #787885;
                mix-blend-mode: normal;
            }

            /* 去除自动填充帐号密码时，input背景为黄色 */
            &:-webkit-autofill {
                box-shadow: 0 0 0px 0px transparent inset !important;
            }

            /* type=number时，去掉控制器 */
            &[type='number']::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }

            &[type='number']::-webkit-outer-spin-button {
                -webkit-appearance: none;
            }
        }

        /* 验证码 */
        .field_code {
            position: absolute;
            top: 50%;
            right: 20px;
            transform: translateY(-50%);
            cursor: pointer;
            font-size: 16px;
            line-height: 22px;
            text-align: right;
            color: var(--primary-color);
            mix-blend-mode: normal;
        }

        /* input清除按钮 */
        .field_clear {
            position: absolute;
            top: 50%;
            right: 20px;
            transform: translateY(-50%);
            cursor: pointer;
        }

        /* input错误提示 */
        .field_errMsg {
            display: inline-block;
            margin-top: 5px;
            font-size: 14px;
            line-height: 20px;
            color: #ff5630;
            animation: shake 0.2s linear both;
        }
    }

    /* 登录按钮 */
    .login_btn {
        width: 100%;
        height: 56px;
        margin-top: 40px;
        background: $base-color-theme;
        border-radius: 4px;
        font-size: 18px;
        color: #ffffff;
        &:hover {
            background: $base-color-theme-deep;
        }
    }

    /* 隐私声明和忘记密码 */
    .login_info {
        margin-top: -10px;
        text-align: right;

        span {
            cursor: pointer;
            font-size: 14px;
            line-height: 20px;
            color: #b7b7bf;
            mix-blend-mode: normal;
        }
    }
}

</style>
